import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { Perks } from "./Perks";

const PerksTab = () => {
  return (
    <div className="t-flex t-justify-center t-h-full">
      <div className="t-basis-[76rem] t-w-full t-h-full">
        <DashboardLayout header={<Header v2 title="Perks" />}>
          <Perks />
        </DashboardLayout>
      </div>
    </div>
  );
};

export default PerksTab;
